import cn from 'classnames';
import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './keto-advantages.module.css';
import KetoContainer from './keto-container';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoAdvantages() {
  return (
    <section className={styles.advantages}>
      <KetoContainer>
        <div className={styles.advantages_inner}>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
          >
            <KetoTypography
              className={styles.advantages_title}
              variant={KetoTypographyVariant.TITLE}
              tag="h1"
            >
              What is Inside the Kitchen?
            </KetoTypography>
          </AnimationOnScroll>

          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
            className={styles.advantage}
          >
            <div className={styles.advantage_start}>
              <KetoTypography
                className={styles.advantage_title}
                variant={KetoTypographyVariant.HEADLINE_1}
                tag="h1"
              >
                Macronutrients
              </KetoTypography>
              <KetoPaper>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_2}
                  tag="p"
                >
                  Carbs are the first macronutrients to control on the Keto,
                  especially when you follow a strict protocol that is
                  prescribed by your doctor. You should also not overeat with
                  Proteins.
                </KetoTypography>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_2}
                  tag="p"
                >
                  Follow the recipe proportions we recommend and we&apos;ll save
                  a lot of your time for calculations. Enjoy the easy meal
                  planning!
                </KetoTypography>
              </KetoPaper>
            </div>
            <div className={styles.advantage_end}>
              <Image
                alt="Advantage №1"
                width={770}
                height={755}
                src="/keto/advantage/images/item1.png"
              />
            </div>
            <img
              alt="fat icon"
              className={styles.fat}
              src="/keto/icons/fat.svg"
            />
            <img
              alt="cap icon"
              className={styles.cap}
              src="/keto/icons/cap.svg"
            />
          </AnimationOnScroll>

          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
            className={cn(styles.advantage, styles.advantage_reverse)}
          >
            <div className={styles.advantage_start}>
              <KetoTypography
                className={styles.advantage_title}
                variant={KetoTypographyVariant.HEADLINE_1}
                tag="h1"
              >
                Healthy Sweets
              </KetoTypography>
              <KetoPaper>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_1}
                  tag="p"
                >
                  Keto is always about tasty and nourishing food. However, when
                  it comes to your desire for something sweet, the sweet-stuff
                  ingredients leave much to be desired.
                </KetoTypography>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_1}
                  tag="p"
                >
                  We invented the variety of candies, cakes and low carb
                  pastries recipes that are delicious and healthy at the same
                  time. We paid a lot of attention to the quality of the
                  products that we recommend. Try sweet Keto with us and
                  you&apos;ll enjoy your Low Carb menu more and more!
                </KetoTypography>
              </KetoPaper>
            </div>
            <div className={styles.advantage_end}>
              <Image
                alt="Advantage №2"
                width={746}
                height={670}
                src="/keto/advantage/images/item2.png"
              />
            </div>
            <img
              alt="bagel icon"
              className={styles.bagel}
              src="/keto/icons/bagel.svg"
            />
          </AnimationOnScroll>

          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
            className={styles.advantage}
          >
            <div className={styles.advantage_start}>
              <KetoTypography
                className={styles.advantage_title}
                variant={KetoTypographyVariant.HEADLINE_1}
                tag="h1"
              >
                New Recipes
              </KetoTypography>
              <KetoPaper>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_1}
                  tag="p"
                >
                  We would like to invite you to our Kitchen and cook healthy
                  dinner together. Watch the weekly video recipes in the app and
                  share the photos of your Keto meals in our community.
                  We&apos;ll choose the winners and award with the monthly
                  subscription. Cool?
                </KetoTypography>
              </KetoPaper>
            </div>
            <div className={styles.advantage_end}>
              <Image
                alt="Advantage №3"
                width={740}
                height={620}
                src="/keto/advantage/images/item3.png"
              />
            </div>
            <img
              alt="orange icon"
              className={styles.orange}
              src="/keto/icons/orange.svg"
            />
          </AnimationOnScroll>
        </div>
      </KetoContainer>
    </section>
  );
}
